import { useState, useEffect } from "react";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";

// Utility function for date formatting
const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

const OrderDetailsModal = ({ creative_id,creative_name, onClose }) => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading(true);
      try {
        const result = await API({
          url: "/alpha_cst_designer/order_details",
          method: "POST",
          data: { creative_id },
        });

        if (result.status === "SUCCESS" && Array.isArray(result.data) && result.data.length > 0) {
          setOrderDetails(result.data[0]);
        } else {
          Toast("error", result.message || "No order details found.");
        }
      } catch (error) {
        Toast("error", "Something went wrong while fetching order details.");
      }
      setLoading(false);
    };

    fetchOrderDetails();
  }, [creative_id]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative w-full max-w-3xl p-6 bg-white rounded shadow-lg">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>

        <div className="flex flex-col gap-2 items-center justify-center mb-4">
            <h2 className="text-2xl font-bold">Order Details</h2>
            <h6 className="px-2 py-1 shadow-md">{creative_name}</h6>
        </div>
        {loading ? (
          <div className="flex justify-center items-center py-10">
            <div className="w-6 h-6 border-4 border-blue-500 border-dotted rounded-full animate-spin"></div>
          </div>
        ) : !orderDetails ? (
          <p className="text-center text-red-600">No details available.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
            <div>
              <span className="font-semibold">Creative ID:</span> {creative_id}
            </div>
            <div>
              <span className="font-semibold">Order ID:</span> {orderDetails.order_id || "N/A"}
            </div>
            <div>
              <span className="font-semibold">Order Name:</span> {orderDetails.order_name || "N/A"}
            </div>
            <div>
              <span className="font-semibold">Start Date:</span>{" "}
              {formatDate(orderDetails.o_start_date)}
            </div>
            <div>
              <span className="font-semibold">End Date:</span>{" "}
              {formatDate(orderDetails.o_end_date)}
            </div>
            <div>
              <span className="font-semibold">Order Value:</span> ₹{orderDetails.order_value || "0"}
            </div>
            <div>
              <span className="font-semibold">Order Type:</span> {orderDetails.order_type || "N/A"}
            </div>
            <div>
              <span className="font-semibold">Verified:</span>{" "}
              {orderDetails.verified === 1 ? "Yes" : "No"}
            </div>
            <div>
              <span className="font-semibold">Is Package:</span>{" "}
              {orderDetails.ispackage ? "Yes" : "No"}
            </div>
            <div>
              <span className="font-semibold">Created Date:</span>{" "}
              {formatDate(orderDetails.created_date)}
            </div>

            {/* Payment Details */}
            <div className="md:col-span-2 border-t pt-3 mt-3">
              <h3 className="font-semibold mb-2">Payment Details</h3>
              {orderDetails.payment_details ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                  <div>
                    <span className="font-semibold">Ref ID:</span>{" "}
                    {orderDetails.payment_details.ref_id || "N/A"}
                  </div>
                  <div>
                    <span className="font-semibold">Received Amount:</span>{" "}
                    ₹{orderDetails.payment_details.received_amount || "0"}
                  </div>
                  <div>
                    <span className="font-semibold">Transaction Date:</span>{" "}
                    {formatDate(orderDetails.payment_details.transaction_date_time)}
                  </div>
                  <div>
                    <span className="font-semibold">UPI ID:</span>{" "}
                    {JSON.parse(orderDetails.payment_details.mode_of_payment || "{}").upi_id ||
                      "N/A"}
                  </div>
                </div>
              ) : (
                <p className="text-gray-500">No payment details available.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const OrderDetails = ({ creative_id, creative_name }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="text-blue-600 hover:underline"
      >
        View Details
      </button>

      {showModal && (
        <OrderDetailsModal
          creative_id={creative_id}
          creative_name={creative_name}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default OrderDetails;
